import { Flex, Skeleton, Stack } from '@mantine/core'

const USER_COLUMN_WIDTHS = [48, 160, 48, 140, 220, 220, 180, 130]

export function UserTableSkeleton() {
	return (
		<Stack sx={{ width: '100%' }} spacing="md" data-testid="user-table-skeleton" aria-busy="true">
			<Flex gap={8} justify="space-between" sx={{ flexWrap: 'wrap' }}>
				<Flex gap={8}>
					<Skeleton height={42} width={180} radius="md" />
					<Skeleton height={42} width={330} radius="md" />
					<Skeleton height={42} width={150} radius="md" />
				</Flex>
				<Flex gap={8}>
					<Skeleton height={32} width={88} radius="md" />
					<Skeleton height={36} width={150} radius="md" />
				</Flex>
			</Flex>

			<div
				style={{
					border: '1px solid #e6ebe7',
					borderRadius: 10,
					overflowX: 'hidden',
					padding: '0 16px',
				}}
			>
				<Flex gap={16} align="center" py={14} sx={{ minWidth: 1100 }}>
					{USER_COLUMN_WIDTHS.map((width, index) => (
						<Skeleton key={index} height={18} width={width} radius="sm" />
					))}
				</Flex>
				{Array.from({ length: 10 }, (_, rowIndex) => (
					<Flex
						key={rowIndex}
						gap={16}
						align="center"
						py={16}
						sx={{ minWidth: 1100, borderTop: '1px solid #edf2ee' }}
					>
						{USER_COLUMN_WIDTHS.map((width, columnIndex) => (
							<Skeleton
								key={columnIndex}
								height={columnIndex === 2 ? 32 : 18}
								width={width}
								radius={columnIndex === 2 ? 'xl' : 'sm'}
							/>
						))}
					</Flex>
				))}
			</div>
		</Stack>
	)
}

export function TabPanelSkeleton() {
	return (
		<Stack sx={{ width: '100%' }} spacing="md" aria-busy="true">
			<Skeleton height={42} width="45%" radius="md" />
			<Skeleton height={520} radius="md" />
		</Stack>
	)
}
